import { XmlSchemaFacet } from './XmlSchemaFacet';

export class XmlSchemaTotalDigitsFacet extends XmlSchemaFacet {}
